export default __webpack_public_path__ + "static/media/brand-20.60f327f1.png";